var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-curvey"},[_c('h3',[_vm._v("Users Reply Back per Day")]),_c('apex-chart',{attrs:{"type":"line","options":_vm.options,"series":_vm.series,"height":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }